'use client';

import { PopoverStyledButton } from '@components/common/Popover/PopoverStyled';
import { cn } from '@utils/cn';
import type { ActionItem } from './usePromptBarActions';

interface PromptBarActionsListProps {
  candidateItems: ActionItem[];
  companyItems: ActionItem[];
  onItemClick: (item: ActionItem) => void;
}

/** Shared `<ul>` of mission items rendered inside every prompt-bar navigation panel. */
export const PromptBarActionsList = ({ candidateItems, companyItems, onItemClick }: PromptBarActionsListProps) => {
  const renderItem = (item: ActionItem) => (
    <li key={item.key}>
      <PopoverStyledButton
        as="button"
        type="button"
        role="menuitem"
        aria-current={item.selected ? 'page' : undefined}
        onClick={() => onItemClick(item)}
        className={cn(
          'flex w-full items-center gap-2 rounded-lg px-3 py-2 text-left text-sm',
          item.selected
            ? 'cursor-default text-ink/40'
            : 'text-ink hover:bg-surface-100',
        )}
      >
        {item.label}
      </PopoverStyledButton>
    </li>
  );

  return (
    <ul role="menu" className="flex flex-col">
      {candidateItems.map(renderItem)}
      <li aria-hidden role="separator" className="my-1">
        <hr className="border-t border-input" />
      </li>
      {companyItems.map(renderItem)}
    </ul>
  );
};
